// extracted by mini-css-extract-plugin
module.exports =  {"collaboration":"jpgCOZpQhlr03FnSowxZ","content":"ULmSyM9YMXQWGDbpg4qr","contentStudent":"CSJ5rf91EqELx4xeLYcQ"};